
<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">Hourly Leave Details</h5>
    <form>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Start Time </label>
          <input disabled type="text" value="{{startTime_fulldate}}" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> End Time </label>
          <input disabled type="text" value="{{endTime_fulldate}}" class="form-control" placeholder="Type here...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Leave Date </label>
          <input disabled type="text" value="{{requestDate}}" class="form-control" placeholder="Type here...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input disabled type="text" value="{{dsc}}" class="form-control" placeholder="Type here...">
        </div>
      </div>
    </form>
  </div>
</div>